import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

import RightArrow from '../../assets/images/right-arrow.png';

export default function LendingSolutionsServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Lending Solutions</title>
        <meta
          name='description'
          content='Through our lending arm, we offer creative financing for acquisitions, construction, and short-term bridge needs. We move quickly, underwrite intelligently, and provide capital that keeps projects moving forward.'
        />
        <meta
          name='keywords'
          content='Lending Solutions, Creative Financing, Acquisitions, Construction, Short-term Bridge Needs'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>Lending Solutions</h2>
        <p className='service-page-text'>
          Through our lending arm, we offer creative financing for acquisitions,
          construction, and short-term bridge needs. We move quickly, underwrite
          intelligently, and provide capital that keeps projects moving forward.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Other Services</h2>
        <div className='service-list'>
          <Link
            to={ROUTE_NAMES.CAPITALVENTURES}
            className='service-block green-block'
          >
            <h3>Capital Ventures</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.EBSERVICE}
            className='service-block'
          >
            <h3>EB-5 & Foreign Capital Consulting</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
